/** @jsxRuntime classic */
/** @jsxFrag React.Fragment */
/** @jsx jsx */
import { jsx } from '@emotion/core'

import { useCallback, useState } from 'react'

import { ColumnsToExport, Dialog, InfoSwatch, InputErrorTooltip, InputFormGroup, KeyWords } from '@bonitour/components'

import { useExportVoucher } from './hooks/useExportVoucher'

import { customTooltip, customTooltipWrapper, customErrorTooltip, customDialog } from './ExportModal.styles'

function ExportModal ({
  toggleModal,
  isVisible,
  vouchersFilters = {}
}) {
  const [isMultiSelectOpened, setIsMultiSelectOpened] = useState(false)
  const {
    format,
    errors,
    onInputChange,
    onOptionChange,
    isChecked,
    onSelectAll,
    isSelectedAll,
    onExport,
    reset,
    exportOptions,
    columnsToExport,
    newEmail,
    setNewEmail,
    emails,
    handleEmails,
    isLoadingExport,
    isExpired,
    isStarted
  } = useExportVoucher(vouchersFilters, toggleModal)

  const onCloseModal = useCallback(() => {
    toggleModal()
    reset()
  }, [reset, toggleModal])

  return (
    <Dialog title='Configuração de exportação da tabela' isVisible={isVisible} onClose={onCloseModal} customContainercss={customDialog}>
      <ColumnsToExport
        isMultiSelectOpen={isMultiSelectOpened}
        toggleMultiSelect={() => setIsMultiSelectOpened(prev => !prev)}
        multiSelectOptions={columnsToExport}
        isChecked={isChecked}
        onInputChange={onInputChange}
        format={format}
        errors={errors}
        onOptionChange={onOptionChange}
        allScheduleChange={onSelectAll}
        areAllSelected={isSelectedAll}
        formatOptions={exportOptions}
        onClick={onExport()}
        onExportAll={onExport(true)}
        loading={isLoadingExport || (isStarted && !isExpired)}
      >
        <InputFormGroup className={'column'} label={<>
            Email(s)
          <InfoSwatch tooltip='Você pode adicionar até 6 e-mails.' customTooltipWrapper={[customTooltipWrapper]} customTooltip={[customTooltip]}/>
        </>}>
          <>
            {(typeof errors?.emails === 'string' && errors?.emails) && <InputErrorTooltip errorMessage={errors?.emails} customCss={[customErrorTooltip]}/>}
            <KeyWords
              keyWords={emails}
              setKeyWords={handleEmails}
              newKeyWord={newEmail}
              setNewKeyWord={setNewEmail}
              errors={errors?.emails}
              max={6}
              alreadyUsedKeyWordLabel={'Este e-mail já foi adicionado'}
              maxHeight={'220px'}
            />
          </>
        </InputFormGroup>
      </ColumnsToExport>
    </Dialog>
  )
}

export default ExportModal
